import React, { useEffect, useState } from "react";
import MultiModalSelector from "../../../components/form/MultiModalSelector";
import Checkbox from "../../../components/InputRaportiDinamik/Checkbox";
import CustomButton from "../../../components/InputRaportiDinamik/Button";
import DefaultInput from "../../../components/form/DefaultInput";
import Input from "../../../components/InputRaportiDinamik/Input";
import DefaultDatePicker from "../../../components/form/DefaultDatePicker";
import dayjs from "dayjs";

type SubmitData = Record<
	string,
	{
		value: any;
		type: string;
		required?: boolean;
	}
>;

type RaportDinamikFormProps = {
	defaultInputValues: SubmitData | null;
	selectedRow?: Record<string, any>;
	onSubmit: (data: SubmitData | null) => void;
	fullPage?: boolean;
};

const RaportDinamikForm: React.FC<RaportDinamikFormProps> = ({
	defaultInputValues,
	selectedRow,
	onSubmit,
	fullPage = false,
}) => {
	const [submitData, setSubmitData] = useState<SubmitData | null>(
		defaultInputValues
	);
	const [isFormOpen, setIsFormOpen] = useState<boolean>(true);

	useEffect(() => {
		setSubmitData(defaultInputValues);
	}, [defaultInputValues]);

	const onToggleForm = (value: boolean) => {
		setIsFormOpen(value);
	};

	const handleChange = (
		parameterName: string,
		value: any,
		parameterType: string
	) => {
		console.log(value, "value", parameterType, "parameterType");
		setSubmitData((prevState: any) => ({
			...prevState,
			[parameterName]: {
				...prevState[parameterName],
				value,
				type: parameterType,
			},
		}));
	};

	const handleRowSelect = (rowData: Array<object>, propertyName: string) => {
		setSubmitData((prevState: any) => ({
			...prevState,
			[propertyName]: {
				...prevState[propertyName],
				value: rowData,
				type: "listotype",
			},
		}));
	};

	const onRowsCleared = (propertyName: string) => {
		handleRowSelect([], propertyName);
	};

	const handleSubmit = () => {
		onSubmit(submitData);
	};

	return (
		<div
			className={`${
				fullPage ? "flex flex-row gap-10 w-full h-full" : ""
			}`}
		>
			<div className="flex pt-3">
				{defaultInputValues && (
					<Checkbox
						onChange={(e) => onToggleForm(e.value)}
						defaultValue={isFormOpen}
						label="Show inputs"
						className="mb-3 mt-3"
					/>
				)}
			</div>
			<div className="flex">
				<form
					onSubmit={(e) => e.preventDefault()}
					noValidate
					style={{
						display: fullPage ? "flex" : "grid",
						gridTemplateColumns: "repeat(2, 1fr)",
					}}
					className={`${
						fullPage
							? "flex-row flex-wrap gap-5"
							: "gap-5 gap-y-3 pb-2 mb-3"
					}`}
				>
					{!!submitData &&
						Object.entries(submitData).map(
							([key, value]: any, i) => {
								const parameterName = key;
								const parameterType = value.type;
								const required = value.required;
								let tipi = "text";

								switch (parameterType) {
									case "int":
									case "double":
									case "bigint":
									case "float":
									case "decimal":
										tipi = "number";
										break;
									case "date":
									case "datetime":
										tipi = "date";
										break;
									case "bit":
									case "bool":
										return (
											<Checkbox
												label={parameterName}
												key={`${value.id}-${i}`}
												onChange={(e: any) => {
													handleChange(
														parameterName,
														e.value,
														parameterType
													);
												}}
												indeterminateEnabled={!required}
												defaultValue={value?.value}
											/>
										);
								}

								if (tipi === "date") {
									return (
										<DefaultDatePicker
											key={`${value.id}-${i}`}
											value={
												value?.value
													? dayjs(value.value)
													: null
											}
											onChange={(selectedDate: any) => {
												handleChange(
													parameterName,
													selectedDate
														? selectedDate.format(
																parameterType ===
																	"datetime"
																	? "YYYY-MM-DD HH:mm:ss"
																	: "YYYY-MM-DD"
														  )
														: null,
													parameterType
												);
											}}
											label={parameterName}
											placeholder={undefined}
											showTime={
												parameterType === "datetime"
											}
										/>
									);
								}

								return (
									<Input
										label={parameterName}
										key={`${value.id}-${i}`}
										type={tipi}
										onChange={(e: any) => {
											handleChange(
												parameterName,
												e.value,
												tipi
											);
										}}
										placeholder="Value"
										value={value?.value}
									/>
								);
							}
						)}
				</form>
			</div>
			{!!selectedRow && isFormOpen && (
				<div
					className={`${
						fullPage ? "flex w-50 items-center pt-3" : ""
					}`}
				>
					<CustomButton onClick={handleSubmit} title="Submit" />
				</div>
			)}
		</div>
	);
};

export default RaportDinamikForm;
